import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapPopupComponent } from './map-popup.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [MapPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [MapPopupComponent],
})
export class MapPopupModule { }
